module.exports = __webpack_public_path__ + "home-block-4-image-2CQ6GXp.jpg";